import EntityCrudPage from '../../shared/EntityCrudPage';
import { dataSourceConfig } from '../../config/entityConfigs';

const DataSourcesPage = () => <EntityCrudPage config={dataSourceConfig} />;

export default DataSourcesPage;
